import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../../content/utils.js';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import PortfolioInfoContainer from '../../../containers/portfolio/PortfolioInfoContainer.jsx';

const ShowPortfolioInfo = ({ portfolioId, slug }) => (
  <>
    <Helmet>
      <title>{getOrgTermsContent('portfolio')} | ChangeSync</title>
    </Helmet>
    <PortfolioInfoContainer portfolioId={portfolioId} slug={slug} />
  </>
);

ShowPortfolioInfo.getInitialProps = ({ query }) => ({
  portfolioId: Number(query.portfolioId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(ShowPortfolioInfo));
